import React from "react";
import { useCallback, useEffect, useState } from "react";
import AxiosInstance from "../../services/AxiosInstance";
import { SOURCE_TYPES_URL } from "../../Constants/Constants";
import Container from "react-bootstrap/Container";
import Box from "@mui/material/Box";
import SourceTypeDialog from "./SourceTypeDialog";
import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  Typography,
} from "@mui/material";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";

function SourceType() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getSourceTypes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(SOURCE_TYPES_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching source types:", error);
      setError("Failed to load source types. Please try again.");
      // showAlert("Failed to load source types", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getSourceTypes();
  }, [getSourceTypes]);

  const columns = [
    {
      field: "name",
      flex: 2,
      headerName: "Source Type Name",
      renderCell: (params) => params.value,
    },
    {
      field: "active",
      flex: 1,
      headerName: "Status",
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          sx={{
            borderRadius: 1,
            fontWeight: 500,
            minWidth: 70,
          }}
        />
      ),
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <SourceTypeDialog
            editSrcTypeId={params.row.id}
            srcTypeName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getSourceTypes}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView
          rows={data}
          cols={columns}
          initialPageSize={5}
          totalElements={data.length}
          rowHeight={60}
        />
      )}
    </Box>
  );
}

export default SourceType;
